import React from 'react'
import classes from 'classnames'
import Scrollspy from 'react-scrollspy'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withState, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

import MainContainer from './Main'
import isMobile from './Main/IsMobileHoc'

import { getItems } from '../store/reducers/about'
import PdfLogo from '../components/Icons/Pdf'
import Link from './../components/Link'

const FAQ = ({ about, toggleCaption, isMobile, opened, setOpened }) => {
  const { items = [] } = about
  const ids = items.map(el => `a-${el.number}`)

  return (
    <div className='Container Container_light'>
      <h1 className='About__item-head Head'>{/*Sidebar__head Sidebar__head_about Head */}
        Наша миссия - создавать <span className='About__item-head-highlight Head'>эффективные</span> инструменты сбора средств для
        помощи некоммерческим организациям и социальным проектам.
      </h1>
      <div className='About__item-row'>
        Всё больше людей практикуют осознанное потребление,
        хотят вносить вклад в развитие общества и быть вовлеченными в благотворительные проекты.
        Бизнесы в свою очередь начинают выстраивать стратегию развития и позиционирования
        не только исходя из увеличения прибыли и своей капитализации,
        но и оценивая свое социальное влияние и экологичность. Поэтому так важно
        объединить желания клиентов и возможности бизнеса, чтобы вместе решать социальные задачи.
      </div>
      <div className='About__item-row'>
        Наша цель - предоставлять людям удобные способы участия в благотворительности
        не нарушая их привычного ритма жизни и увеличивая таким образом потоки пожертвований в фонды.
      </div>
      <div className='About__item-row'>
        Мы объединяем <a href={'/funds'} target='_blank' className='Link Link_orange'>
          Фонды
                </a>, <a href={'/externalpartners'} target='_blank' className='Link Link_orange'>
          Бизнесы
                </a> и <a className='Link_orange'>
          Людей
                </a>, желающих внести вклад в социальное
        развитие общества, разрабатывая и внедряя технологичные, современные
        благотворительные инструменты.
      </div>
      <div className="About__pdf">
      <a href="/assets/docs/ustav.pdf" download="ustav.pdf">
        <button type="button" className="About__pdf-button"><PdfLogo /></button>
        <div className="About__pdf-text">Устав</div>
      </a>
      </div>
      <div className='About__item-row-center'>
        <Link to="/actions">
          <button className='Button Button_black'> {/*onClick={get.bind(this, { offset: items.length })} loading={fetching.button} */}
          Посмотреть все акции
        </button>
        </Link>
      </div>
      <h1 className='About__item-head Head'>{/*Sidebar__head Sidebar__head_about Head */}
        Мы делаем благотворительные проекты эффективными, современными, доступными
        и прозрачными.
      </h1>
      <div className='About__last-row About__item-row'>
      <a href='https://meetforcharity.today/' target='_blank' className='Link About__last-col'>Meet For Charity</a>
      <a href='https://karantinder.ru/' target='_blank' className='Link About__last-col'>Карантиндер</a>
      </div>
    </div>

    /*<MainContainer
      sidebarNoBody
      sidebarClass='Sidebar_about'
      Sidebar={
        <div>
          <h1 className='Sidebar__head Sidebar__head_about Head'>
            <FormattedMessage id='about.about' />
          </h1>
          <div className='About__list'>
            <Scrollspy items={ids} currentClassName='About__item_current' componentTag='div'>
              {items.map(el => (
                <div className='About__item' id={`q-${el.number}`} key={el.number}>
                  <div className='About__item-head' onClick={setOpened.bind(this, el.number)}>Q: {el.question}</div>
                  <div className={classes('About__item-caption', { 'About__item-caption_show': opened[el.number] })}>
                    <div className='About__item-caption-body' dangerouslySetInnerHTML={{ __html: el.answer }} />
                  </div>
                </div>
              ))}
            </Scrollspy>
          </div>
        </div>
      }
    >
      {!isMobile && (
        <div>
          {items.map(el => (
            <div className='Main__title SubHead About__caption' id={`a-${el.number}`} key={el.number} dangerouslySetInnerHTML={{ __html: el.answer }} />
          ))}
        </div>
      )}
    </MainContainer>*/
  )
}

const mapStateToProps = ({ about }) => ({ about })

const mapDispatchToProps = dispatch => bindActionCreators({ getItems }, dispatch)

export default compose(
  isMobile,
  connect(mapStateToProps, mapDispatchToProps),
  withState('opened', 'setOpened', {}),
  withHandlers({
    setOpened: ({ setOpened, opened }) => (i, e) => {
      let flag = !opened[i]
      let $caption = e.target.nextSibling
      let height = $caption.offsetHeight

      opened[i] = flag
      if (!flag) $caption.style.maxHeight = '0px'

      if (flag) {
        setOpened(opened, () => {
          $caption.style.maxHeight = '0px'
          setTimeout(() => {
            $caption.style.maxHeight = `${height}px`
          }, 10)
        })
      } else {
        $caption.style.maxHeight = '0px'
        setTimeout(() => {
          setOpened(opened, () => {
            $caption.style.maxHeight = null
          })
        }, 300)
      }
    }
  }),
  lifecycle({
    componentWillMount() {
      this.props.getItems()
    }
  })
)(FAQ)

// class FAQ extends Component {
//   constructor (props) {
//     super(props)

//     this.handleScroll = this.handleScroll.bind(this)
//     this.calcPoint = this.calcPoint.bind(this)

//     this.toggleCaption = this.toggleCaption.bind(this)
//   }

//   componentWillMount () {
//     this.props.getItems()
//     this.setState({
//       isAbsolute: false,
//       point: 0
//     })
//   }

//   componentDidMount () {
//     global.addEventListener('scroll', this.handleScroll)
//     global.addEventListener('resize', this.calcPoint)
//     global.addEventListener('load', this.calcPoint)
//     this.calcPoint()

//     $steps = document.querySelectorAll('.About__item-caption')

//     function setSataSet () {
//       for (var i = $steps.length - 1; i >= 0; i--) {
//         $steps[i].dataset.height = $steps[i].offsetHeight
//       }
//     }

//     global.addEventListener('resize', setSataSet)
//     setSataSet()
//   }

//   componentWillUnmount () {
//     global.removeEventListener('scroll', this.handleScroll)
//     global.removeEventListener('resize', this.calcPoint)
//     global.removeEventListener('load', this.calcPoint)
//   }

//   calcPoint () {
//     this.setState({ point: (this.container.offsetTop + this.container.offsetHeight - global.innerHeight) + ((global.innerWidth / 1366) * 70) })
//   }

//   handleScroll () {
//     const { point } = this.state

//     if (global.pageYOffset > point && !this.state.isAbsolute) {
//       this.setState({ isAbsolute: true })
//     }

//     if (global.pageYOffset < point && this.state.isAbsolute) {
//       this.setState({ isAbsolute: false })
//     }
//   }

//   toggleCaption (e) {
//     const $caption = e.target.nextSibling

//     if ($caption.classList.contains('About__item-caption_show')) {
//       $caption.style.maxHeight = '0px'

//       setTimeout(() => {
//         $caption.classList.remove('About__item-caption_show')
//         $caption.style.maxHeight = null
//       }, 300)
//     } else {
//       $caption.classList.add('About__item-caption_show')
//       $caption.style.maxHeight = '0px'

//       setTimeout(() => {
//         $caption.style.maxHeight = `${$caption.dataset.height}px`
//       }, 10)
//     }
//   }

//   render () {
//     const { items } = this.props.about
//     let isMob = isMobile()

//     return (
//       <div className='Container About' ref={el => { this.container = el }} >
//         <div className={classes('Sidebar', 'Sidebar_about', {
//           'Sidebar_absolute': this.state.isAbsolute && isMob
//         })} style={{
//           top: (this.state.isAbsolute && !isMob) ? this.state.point - ((global.innerWidth / 1366) * 150) : null
//         }}>
//           <h1 className='Sidebar__head Sidebar__head_about Head'>О нас</h1>
// <div className='About__list'>
//   <Scrollspy items={['section-1', 'section-2', 'section-3', 'section-4']} currentClassName='About__item_current' componentTag='div'>
//     {items.map((el, i) => (
//       <div className='About__item' id={`faq-content-${i}`} key={i}>
//         <div className='About__item-head' onClick={this.toggleCaption}>Q: {el.question}</div>
//         <div className='About__item-caption'>
//           {/* <p className='About__item-caption-body'></p> */}
//           <div dangerouslySetInnerHTML={{ __html: el.answer }} />
//         </div>
//       </div>
//     ))}
//   </Scrollspy>
// </div>
//         </div>
//         {!isMob &&
//           <div className='Main'>
// {items.map((el, i) => (
//   <div className='Main__title SubHead About__caption' id={`faq-content-${i}`} key={i} dangerouslySetInnerHTML={{ __html: el.answer }} />
// ))}
//           </div>
//         }
//       </div>
//     )
//   }
// }



// WEBPACK FOOTER //
// ./src/containers/About.jsx